import { useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../../constants/common'
import {
  ListItemNavigationDirection,
  useListItemNavigation,
  useMinimizedModalsContext,
  useOutboundUuid,
} from '../../../../../../hooks'
import { MINIMIZED_MODAL_SCOPE } from '../../../../../Modal'
import { getRequestThreadNavigation } from '../../../RequestProfileTabEmails.api'

export function useRequestProfileTabEmailsThreadModalNavigation({
  initialUuid,
  navigationContext,
}) {
  const isEnabled = Boolean(navigationContext)

  const outboundUuid = useOutboundUuid()

  const { confirmBeforeAction } = useMinimizedModalsContext()

  const [current, setCurrent] = useState({ anchor: null, uuid: initialUuid })

  const { filterValues, ordering, requestId } =
    navigationContext ?? EMPTY_OBJECT

  async function loadNavigation({ options, uuid }) {
    return getRequestThreadNavigation({
      data: {
        filters: filterValues ?? EMPTY_OBJECT,
        ordering: ordering ?? EMPTY_LIST,
      },
      options,
      outboundUuid,
      requestId,
      threadUuid: uuid,
    })
  }

  const { index, isLoaded, nextUuid, previousUuid, total } =
    useListItemNavigation({
      anchor: current.anchor,
      isEnabled,
      loadNavigation,
      uuid: current.uuid,
    })

  function goToThread(uuid, direction) {
    if (uuid) {
      confirmBeforeAction(
        () =>
          setCurrent({
            anchor: { direction, nextUuid, previousUuid, uuid: current.uuid },
            uuid,
          }),
        { scope: MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE_EMAIL_THREAD }
      )
    }
  }

  function handlePrevious() {
    goToThread(previousUuid, ListItemNavigationDirection.Previous)
  }

  function handleNext() {
    goToThread(nextUuid, ListItemNavigationDirection.Next)
  }

  // The successor takes the removed thread's place; at the list tail step back
  function handleCurrentThreadRemoved() {
    const targetUuid = nextUuid ?? previousUuid

    if (targetUuid) {
      setCurrent({ anchor: null, uuid: targetUuid })
    }

    return Boolean(targetUuid)
  }

  return {
    currentIndex: index,
    currentUuid: current.uuid,
    handleCurrentThreadRemoved,
    handleNext,
    handlePrevious,
    hasNext: Boolean(nextUuid),
    hasPrevious: Boolean(previousUuid),
    isLoading: isEnabled && !isLoaded,
    totalCount: total,
  }
}
